module.exports = __webpack_public_path__ + "img/boda-preparacion-thumbnail.0fe2b65a.jpg";